import { redirectIfNotAdmin } from "@/utils/url";
import { QueryClient } from "@tanstack/react-query";

export function loader(queryClient: QueryClient) {
  return async () => {
   return await redirectIfNotAdmin(queryClient);
  };
}
